import PropTypes from 'prop-types';

const CopyCodeIllustration = ({ className = '' }) => {
  return (
    <svg
      width="99"
      height="72"
      viewBox="0 0 99 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M98.3196 0.228516H0V71.2285H98.3196V0.228516Z" fill="#FFCCEF" />
      <path
        d="M19.3971 14.1834C21.4012 14.1834 23.0259 12.5587 23.0259 10.5546C23.0259 8.55045 21.4012 6.92578 19.3971 6.92578C17.393 6.92578 15.7683 8.55045 15.7683 10.5546C15.7683 12.5587 17.393 14.1834 19.3971 14.1834Z"
        fill="#FB6E44"
      />
      <path
        d="M29.7562 14.1834C31.7604 14.1834 33.385 12.5587 33.385 10.5546C33.385 8.55045 31.7604 6.92578 29.7562 6.92578C27.7521 6.92578 26.1274 8.55045 26.1274 10.5546C26.1274 12.5587 27.7521 14.1834 29.7562 14.1834Z"
        fill="#FB6E44"
      />
      <path
        d="M9.03993 14.1834C11.0441 14.1834 12.6687 12.5587 12.6687 10.5546C12.6687 8.55045 11.0441 6.92578 9.03993 6.92578C7.0358 6.92578 5.41113 8.55045 5.41113 10.5546C5.41113 12.5587 7.0358 14.1834 9.03993 14.1834Z"
        fill="#FB6E44"
      />
      <path
        d="M92.6894 25.8691H5.62939V45.5891H92.6894V25.8691Z"
        fill="white"
      />
      <path
        d="M67.6616 41.3164L69.362 59.3567L84.1364 48.8539L67.6616 41.3164Z"
        fill="#0A0777"
      />
      <path
        d="M76.9969 50.9248L73.6755 53.2852L80.8887 63.4351L84.2101 61.0747L76.9969 50.9248Z"
        fill="#0A0777"
      />
    </svg>
  );
};

CopyCodeIllustration.propTypes = {
  className: PropTypes.string
};

export default CopyCodeIllustration;
